import { getAdminUrl } from '../application-api'

export const descriptionImageUploadUrl = function () {
  return getAdminUrl('/description/image')
}
